/**
 * 認証確認の経過をブラウザに記録する。
 *
 * BT・本番で Loading… が消えない報告があり、根本原因が未特定のまま残っている。
 * 再発したときに、画面がどこで止まったのかと Cloud Run 側の処理時間を
 * X-Request-ID で突き合わせられるようにする（PRI-251）。
 *
 * utils/logger を使わないのは、あれが本番で ERROR しか出さないため。この記録は
 * 本番で採取することが目的なので、そのフィルタを通さない。
 *
 * Cookie とトークンは記録しない。出せるフィールドをここで固定している。
 */

export type AuthProbePhase =
  /** 認証確認のリクエストを投げた */
  | 'started'
  /** 認証済みとして解決した */
  | 'succeeded'
  /** 未認証として解決した（401） */
  | 'unauthenticated'
  /** 通信または権限解決に失敗した */
  | 'failed'
  /** 待たせすぎているので利用者に知らせた */
  | 'slow'
  /** 上限に達したので打ち切った */
  | 'timed-out'
  /** 新しい認証確認に追い越された。この requestId の結果は捨てる */
  | 'superseded'

export type AuthProbeTrigger = 'initial' | 'refresh' | 'retry'

export interface AuthProbeEvent {
  phase: AuthProbePhase
  requestId: string
  /** 認証確認を開始してからの経過時間。開始時点では出さない */
  elapsedMs?: number
  /** 失敗の区別に使う短い識別子。本文やヘッダは入れない */
  reason?: string
  /** 何がこの認証確認を始めたか。started でのみ出す */
  trigger?: AuthProbeTrigger
}

export function recordAuthProbe(event: AuthProbeEvent): void {
  console.info(
    JSON.stringify({
      timestamp: new Date().toISOString(),
      channel: 'auth-probe',
      ...event,
    }),
  )
}
